import api from '@utils/api'

import { SET_CATALOG } from '@constants/actionType'

import {
  StatusVisible,
} from '@constants/general'

export const getCoutries = (querys) => async (dispatch, _getState) => {
  const response = await api.getAllCountries(querys)
  if (querys.type === 'visible') {
    if (!response?.status) {
      dispatch({
        type: SET_CATALOG,
        payload: {nameCatalog: 'countriesCatalog', data: response.data}
      })
    }
  }
  return response;
};

export const reOrderCountries = (data) => async (_dispatch, _getState) => {
  const response = await api.reOrderCountries(data)
  return response;
};
export const updateVisibilityStatus = ({ id, justification, visible }) => async (_dispatch, _getState) => {
  let validateStatus = null
  if (visible === StatusVisible.IS_VISIBLE) validateStatus = 'hide'
  if (visible === StatusVisible.IS_HIDDEN) validateStatus = 'show'
  const data = {
    status: validateStatus,
    reason: justification
  }
  const response = await api.updateVisibilityCountry(id, data)
  return response;
};

export const newCountry  = ({name, clave}) => async (_dispatch, _getState) => {
  const data = {
    nombre: name,
    clave
  }
  const response = await api.addCountry(data)
  return response;
};

export const editCountry  = ({id, name, justification, clave}) => async (_dispatch, _getState) => {
  const data = {
    id,
    nombre: name,
    clave,
    reason: justification
  }
  const response = await api.editCountry(data)
  return response;
};

export const getCountriesOfficials = () => async (_dispatch, _getState) => {
  const response = await api.getCountriesOfficials()
  return response;
};